import { CalendarConnectionResponse } from '../types/booking';
import { SERVICES_API_BASE_URL } from './apiConfig';

export interface EmailConnection {
  provider: number;
  email: string;
  connectedAt: string;
}

export interface YahooSMTPRequest {
  email: string;
  password: string;
  smtpHost: string;
  smtpPort: number;
}

const API_URL = `${SERVICES_API_BASE_URL}/api/EmailConnection`;

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
});

const fetchJson = async <T>(
  url: string,
  options?: RequestInit
): Promise<T> => {
  const response = await fetch(url, {
    ...options,
    headers: {
      ...getHeaders(),
      ...(options?.headers || {}),
    },
  });

  if (!response.ok) {
    const error = await response
      .json()
      .catch(() => ({ message: 'Request failed' }));

    throw new Error(error.message || 'Request failed');
  }

  return response.json();
};

export const emailConnectionApi = {
  async getActive(): Promise<CalendarConnectionResponse | null> {
    const response = await fetch(`${API_URL}/active`, {
      headers: getHeaders(),
    });

    if (response.status === 404) {
      return null;
    }

    if (!response.ok) {
      throw new Error('Failed to fetch active connection');
    }

    return response.json();
  },

  async connectGoogle(): Promise<{ authUrl: string }> {
    return fetchJson<{ authUrl: string }>(
      `${API_URL}/google/connect`
    );
  },

  async connectMicrosoft(): Promise<{ authUrl: string }> {
    return fetchJson<{ authUrl: string }>(
      `${API_URL}/microsoft/connect`
    );
  },

  async disconnect(): Promise<void> {
    const response = await fetch(`${API_URL}/disconnect`, {
      method: 'DELETE',
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to disconnect email');
    }
  },

  async connectYahooSMTP(
    data: YahooSMTPRequest
  ): Promise<void> {
    const response = await fetch(`${API_URL}/smtp/connect`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response
        .json()
        .catch(() => ({ message: 'Failed to connect Yahoo email' }));

      throw new Error(error.message);
    }
  },
};